// extracted by mini-css-extract-plugin
export var header = "_th-1";
export var maskBottom = "_th-6";
export var maskMiddle = "_th-7";
export var maskTop = "_th-5";
export var root = "_th-0";
export var scrollDownButton = "_th-3";
export var scrollDownButtonHidden = "_th-4";
export var viewport = "_th-2";